import { render, staticRenderFns } from "./ReferralDetail.vue?vue&type=template&id=5d44d0c4&"
import script from "./ReferralDetail.vue?vue&type=script&lang=js&"
export * from "./ReferralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports